import { useQuery } from 'react-query';
import request from '../../../helpers/request';

const getTypes = async () => {
  return await request.get(
    '/Information/types',
    {},
    'При загрузке типов информирования произошла ошибка'
  );
};

export const createInfoTypesKeys = () => ['infoTypes'];

const useInfoTypes = (options) =>
  useQuery(createInfoTypesKeys(), getTypes, options);

export default useInfoTypes;
